import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ITDashboard from './it/ITDashboard';
import ITAssetRegister from './it/ITAssetRegister';
import ITAllocations from './it/ITAllocations';
import ITServiceRequests from './it/ITServiceRequests';

export default function IT() {
  return (
    <div data-testid="it-page">
      <Routes>
        <Route index element={<Navigate to="dashboard" replace />} />
        <Route path="dashboard" element={<ITDashboard />} />
        <Route path="assets" element={<ITAssetRegister />} />
        <Route path="allocations" element={<ITAllocations />} />
        <Route path="requests" element={<ITServiceRequests />} />
      </Routes>
    </div>
  );
}
